import React from "react";
import { Box } from "@mui/material";
import { Spinner } from "components/Spinner";
import queryString from 'query-string'
import utils from '../../libs/utils'

const parsedQuery = queryString.parse(window.location.search);
const clientID = parsedQuery.clientid as string
const correlationID = parsedQuery.cid as string

function buildRedirectUri() {
  return new URL(process.env.REACT_APP_CONNECT + '/popup/general/finish.html', window.location.href).toString();
}

function getAction(action: string) {
  let url = '';
  switch (action) {
      case 'manage-wallets':
          url = '/wallets/manage';
          break;
      case 'link-wallets':
          url = '/wallets/link';
          break;
      case 'claim-wallets':
          url = '/wallets/claim';
          break;
      default:
          return '/invalid?act=' + action;
  }
  return utils.buildUrl(url, {redirectUri: buildRedirectUri(), correlationID: correlationID});
}

function onMessage(event: any) {
  if (event && event.data) {
      if (event.data.type === 'SEND_DATA') {
          var params = Object.assign({}, event.data.params);
          var action = process.env.REACT_APP_API + getAction(params.action);

          if (action !== 'invalid') {
              console.log('post form ' + action)
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = action;
              utils.addHiddenInput(form, 'clientid', clientID);
              utils.addHiddenInput(form, 'bearerToken', params.bearerToken);
              utils.addHiddenInput(form, 'data', JSON.stringify(Object.assign({}, params.data)));
              document.body.appendChild(form);
              form.submit();
          } else {
              console.log('redirect back')
              window.location.href = utils.addRequestParams(buildRedirectUri(), {status: 'FAILED', error: 'Invalid action: ' + params.action + '"'});
          }
      }
  }
}
window.addEventListener('message', onMessage.bind(this));
window?.opener?.postMessage({type: 'POPUP_MOUNTED', correlationID: correlationID}, '*');
export default function PopupTransactionInit() {
  return (
    <Box p={10} display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh">
      <Spinner color="black" />
    </Box>
  );
}